export default __webpack_public_path__ + "assets/search.60124011.svg";